import { injectGlobal } from "styled-components"
import { normalize } from "polished"

export default injectGlobal`
    ${normalize()}

    html {
        box-sizing: border-box;
        font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif !default;
        line-height: 1.15;
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
        -ms-overflow-style: scrollbar;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
    }

    *,
    *::before,
    *::after {
        box-sizing: inherit;
    }
`



// WEBPACK FOOTER //
// ./src/UI/DefaultStyles/index.js